import React, { Component } from "react";

//  Images

// Libs
import { Modal } from "react-bootstrap";
import _ from "lodash";
import { render } from "react-dom";
import { imageUrl } from "../actions/miscAction";

const conditionOptions = [
  "New",
  "New Surplus",
  "Used",
  "Damaged",
  "Scrap",

  "Factory New",
  "Overhauled",
  "Serviceable",
  "As Removed",
  "Repairable",
  "Repaired",
  "Inspected",
  "Core",

  "Beyond Economical Repair",
  "Rebuilt",
  "Modified",

  "Tested",
  "Unserviceable",

  "Disposal",
  "Disposal/Free",
];

class MobileDropdown extends Component {
  state = {
    tab: 1,
    filtersShow: 6,
    defaultActiveKey: ["0"],
  };
  handleToggle = (id) => {
    const { defaultActiveKey } = this.state;
    const findId = defaultActiveKey.find((key) => key === id);
    if (findId) {
      this.setState({
        defaultActiveKey: defaultActiveKey.filter((key) => key !== id),
      });
    } else {
      const newData = [...defaultActiveKey, ...[id]];
      this.setState({ defaultActiveKey: newData });
    }
  };
  showMore = (counts, data, type) => {
    this.props.filterModalDataCounts(counts);
    this.props.filterModalData(data);
    this.props.toggleFilter();
    this.props.modalType(type);
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.showModal && this.props.showModal !== prevProps.showModal) {
      const { facets } = this.props;
      const cat =
        facets["categories.lvl0"] &&
        Object.keys(facets["categories.lvl0"]).sort(function (a, b) {
          var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
          var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });

      const subCat =
        facets["categories.lvl1"] &&
        Object.keys(facets["categories.lvl1"]).sort(function (a, b) {
          var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
          var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });

      const subCatLevel2 =
        (facets["categories.lvl2"] &&
          Object.keys(facets["categories.lvl2"]).sort(function (a, b) {
            var textA = facets["categories.lvl2"][a];
            var textB = facets["categories.lvl2"][b];
            return textB - textA;
          })) ||
        [];
      const aviationModel =
        (facets["aviation_model_name"] &&
          Object.keys(facets["aviation_model_name"]).sort(function (a, b) {
            var textA = facets["aviation_model_name"][a];
            var textB = facets["aviation_model_name"][b];
            return textB - textA;
          })) ||
        [];

      const makefilter =
        facets["make"] &&
        Object.keys(facets["make"]).sort(function (a, b) {
          var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
          var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });

      const modelfilter =
        facets["model"] &&
        Object.keys(facets["model"]).sort(function (a, b) {
          var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
          var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });

      const regionfilter =
        facets["region"] &&
        Object.keys(facets["region"]).sort(function (a, b) {
          var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
          var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });

      const subRegionfilter =
        facets["regions.lvl1"] &&
        Object.keys(facets["regions.lvl1"]).sort(function (a, b) {
          var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
          var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });

      if (cat && cat.length > 0) {
        this.setState({ tab: 1 });
      } else if (subCat && subCat.length > 0) {
        this.setState({ tab: 2 });
      } else if (subCatLevel2?.length > 0) {
        this.setState({ tab: 7 });
      } else if (aviationModel?.length > 0) {
        this.setState({ tab: 8 });
      } else if (makefilter && makefilter.length > 0) {
        this.setState({ tab: 3 });
      } else if (modelfilter && modelfilter.length > 0) {
        this.setState({ tab: 4 });
      } else if (regionfilter && regionfilter.length > 0) {
        this.setState({ tab: 5 });
      } else if (subRegionfilter && subRegionfilter.length > 0) {
        this.setState({ tab: 6 });
      }
    }
    if (!this.props.loadingMain && this.props.loadingMain !== prevProps.loadingMain) {
      const { facets } = this.props;
      const cat =
        facets["categories.lvl0"] &&
        Object.keys(facets["categories.lvl0"]).sort(function (a, b) {
          var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
          var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });

      const subCat =
        facets["categories.lvl1"] &&
        Object.keys(facets["categories.lvl1"]).sort(function (a, b) {
          var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
          var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
      const subCatLevel2 =
        (facets["categories.lvl2"] &&
          Object.keys(facets["categories.lvl2"]).sort(function (a, b) {
            var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
            var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          })) ||
        [];
      const aviationModel =
        (facets["aviation_model_name"] &&
          Object.keys(facets["aviation_model_name"]).sort(function (a, b) {
            var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
            var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          })) ||
        [];
      const makefilter =
        facets["make"] &&
        Object.keys(facets["make"]).sort(function (a, b) {
          var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
          var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
      const modelfilter =
        facets["model"] &&
        Object.keys(facets["model"]).sort(function (a, b) {
          var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
          var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
      const regionfilter =
        facets["region"] &&
        Object.keys(facets["region"]).sort(function (a, b) {
          var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
          var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
      const subRegionfilter =
        facets["regions.lvl1"] &&
        Object.keys(facets["regions.lvl1"]).sort(function (a, b) {
          var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
          var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
      // if (cat && cat.length > 0) {
      //   this.setState({ tab: 1 });
      // } else if (subCat && subCat.length > 0) {
      //   this.setState({ tab: 2 });
      // } else if (subCatLevel2?.length > 0) {
      //   this.setState({ tab: 7 });
      // } else if (aviationModel?.length > 0) {
      //   this.setState({ tab: 8 });
      // } else if (makefilter && makefilter.length > 0) {
      //   this.setState({ tab: 3 });
      // } else if (modelfilter && modelfilter.length > 0) {
      //   this.setState({ tab: 4 });
      // } else if (regionfilter && regionfilter.length > 0) {
      //   this.setState({ tab: 5 });
      // } else if (subRegionfilter && subRegionfilter.length > 0) {
      //   this.setState({ tab: 6 });
      // }
    }
  };

  render() {
    const leftArrowIcon = imageUrl("chevron-left-angle.svg");

    const { catagory, catagory1, catagory2, conditionType, make, model, region, region1, removeFilter } = this.props;
    const aviationModelData = this?.props?.aviationModel;
    const { facets } = this.props;
    const cat =
      facets["categories.lvl0"] &&
      Object.keys(facets["categories.lvl0"]).sort(function (a, b) {
        var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
        var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });

    const subCat =
      facets["categories.lvl1"] &&
      Object.keys(facets["categories.lvl1"]).sort(function (a, b) {
        var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
        var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
    const subCatLevel2 =
      (facets["categories.lvl2"] &&
        Object.keys(facets["categories.lvl2"]).sort(function (a, b) {
          var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
          var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        })) ||
      [];
    const aviationModel =
      (facets["aviation_model_name"] &&
        Object.keys(facets["aviation_model_name"]).sort(function (a, b) {
          var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
          var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        })) ||
      [];
    const condition =
      (facets["conditionType"] &&
        Object.entries(facets["conditionType"])
          .sort(function (a, b) {
            var textA = facets["conditionType"][a];
            var textB = facets["conditionType"][b];
            return textB - textA;
          })
          .filter(
            (item) => conditionOptions?.includes(item[0]?.split("-")?.[1]) || conditionOptions?.includes(item[0]),
          )) ||
      [];
    const makefilter =
      facets["make"] &&
      Object.keys(facets["make"]).sort(function (a, b) {
        var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
        var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });

    const modelfilter =
      facets["model"] &&
      Object.keys(facets["model"]).sort(function (a, b) {
        var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
        var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });

    const regionfilter =
      facets["region"] &&
      Object.keys(facets["region"]).sort(function (a, b) {
        var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
        var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });

    const subRegionfilter =
      facets["regions.lvl1"] &&
      Object.keys(facets["regions.lvl1"]).sort(function (a, b) {
        var textA = a.replace(/[^\w\s]/gi, "").toUpperCase();
        var textB = b.replace(/[^\w\s]/gi, "").toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });

    const activeFilters = [
      ...catagory,
      ...catagory1,
      ...catagory2,
      ...conditionType,
      ...aviationModelData,
      ...make,
      ...model,
      ...region,
      ...region1,
    ];
    const showFilters = _.take(activeFilters, this.state.filtersShow);
    return (
      <Modal
        className={"modal left-collapse fade"}
        show={this.props.showModal}
        onHide={this.props.toggleModal}
        id="filterCollapse"
        tabindex="-1"
        role="dialog"
      >
        <div class="filter-collapse-content">
          <div className="fcc-header d-flex align-items-center justify-content-center position-relative">
            <div
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={this.props.toggleModal}
              style={{ position: "absolute", left: "20px" }}
            >
              <img src={leftArrowIcon} alt="leftArrowIcon" style={{ height: "1rem" }} />
            </div>
            <h3 class="fcc-title" id="myModalLabel">
              Filters
            </h3>
            <small
              style={{ position: "absolute", right: "20px" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.clearFilter("all");
                this.props.toggleModal();
              }}
            >
              {activeFilters.length > 0 ? " Clear filters" : ""}
            </small>
          </div>
          <div className="fcc-body">
            <div class="fcc-tab-container d-flex">
              <div class="nav flex-column nav-pills h-100" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                {cat && cat.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 1 && "active"}`}
                    id="v-pills-tab-A-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-A"
                    role="tab"
                    aria-controls="v-pills-tab-A"
                    aria-selected="true"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 1 });
                    }}
                  >
                    Category
                  </a>
                )}
                {subCat && subCat.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 2 && "active"}`}
                    id="v-pills-tab-A-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-A"
                    role="tab"
                    aria-controls="v-pills-tab-A"
                    aria-selected="true"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 2 });
                    }}
                  >
                    Sub Category
                  </a>
                )}
                {subCatLevel2 && subCatLevel2.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 7 && "active"}`}
                    id="v-pills-tab-A-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-A"
                    role="tab"
                    aria-controls="v-pills-tab-A"
                    aria-selected="true"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 7 });
                    }}
                  >
                    Part Type
                  </a>
                )}
                {aviationModel && aviationModel.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 8 && "active"}`}
                    id="v-pills-tab-A-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-A"
                    role="tab"
                    aria-controls="v-pills-tab-A"
                    aria-selected="true"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 8 });
                    }}
                  >
                    Plane Model
                  </a>
                )}
                {condition && condition.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 9 && "active"}`}
                    id="v-pills-tab-A-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-A"
                    role="tab"
                    aria-controls="v-pills-tab-A"
                    aria-selected="true"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 9 });
                    }}
                  >
                    Condition
                  </a>
                )}
                {makefilter && makefilter.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 3 && "active"}`}
                    id="v-pills-tab-A-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-A"
                    role="tab"
                    aria-controls="v-pills-tab-A"
                    aria-selected="true"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 3 });
                    }}
                  >
                    Manufacturer
                  </a>
                )}
                {/* {modelfilter && modelfilter.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 4 && "active"}`}
                    id="v-pills-tab-A-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-A"
                    role="tab"
                    aria-controls="v-pills-tab-A"
                    aria-selected="true"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 4 });
                    }}
                  >
                    Plane Model
                  </a>
                )} */}
                {regionfilter && regionfilter.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 5 && "active"}`}
                    id="v-pills-tab-B-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-B"
                    role="tab"
                    aria-controls="v-pills-tab-B"
                    aria-selected="false"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 5 });
                    }}
                  >
                    Region
                  </a>
                )}
                {subRegionfilter && subRegionfilter.length > 0 && (
                  <a
                    class={`nav-link ${this.state.tab === 6 && "active"}`}
                    id="v-pills-tab-C-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-pane-C"
                    role="tab"
                    aria-controls="v-pills-tab-C"
                    aria-selected="false"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ tab: 6 });
                    }}
                  >
                    Sub Region
                  </a>
                )}
              </div>
              <div class="tab-content" id="v-pills-tabContent">
                <div
                  class={`tab-pane fade ${this.state.tab === 1 && "show active"}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box">
                    {cat &&
                      cat.length > 0 &&
                      cat
                        .sort((a, b) => facets["categories.lvl0"][b] - facets["categories.lvl0"][a])
                        .map((v) =>
                          v?.includes("_") ? (
                            <div class="form-check d-flex align-items-center">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id={v}
                                checked={catagory.find((ev) => ev === v) ? true : false}
                              />
                              <label class="form-check-label" for={v} onClick={() => this.props.setData("catagory", v)}>
                                {`${v.split("_")[0]} (${facets["categories.lvl0"][v]})`}
                              </label>
                            </div>
                          ) : (
                            ""
                          ),
                        )}
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${this.state.tab === 2 && "show active"}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    {subCat &&
                      subCat.length > 0 &&
                      subCat
                        .sort((a, b) => facets["categories.lvl1"][b] - facets["categories.lvl1"][a])
                        .map((v) =>
                          v?.includes("_") ? (
                            <div class="form-check d-flex align-items-center">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id={v}
                                checked={catagory1.find((ev) => ev === v) ? true : false}
                              />
                              <label
                                class="form-check-label"
                                for={v}
                                onClick={() => this.props.setData("catagory1", v)}
                              >
                                {`${v.split(">")?.[1]?.split("_")[0]} (${facets["categories.lvl1"][v]})`}
                              </label>
                            </div>
                          ) : (
                            ""
                          ),
                        )}
                  </div>
                </div>{" "}
                <div
                  class={`tab-pane fade ${this.state.tab === 7 && "show active"}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    {subCatLevel2 &&
                      subCatLevel2.length > 0 &&
                      subCatLevel2
                        .sort((a, b) => facets["categories.lvl2"][b] - facets["categories.lvl2"][a])
                        .map((v) =>
                          v?.includes("_") ? (
                            <div class="form-check d-flex align-items-center">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id={v}
                                checked={catagory2.find((ev) => ev === v) ? true : false}
                              />
                              <label
                                class="form-check-label"
                                for={v}
                                onClick={() => this.props.setData("catagory2", v)}
                              >
                                {`${v.split(">")?.[2]?.split("_")[0]} (${facets["categories.lvl2"][v]})`}
                              </label>
                            </div>
                          ) : (
                            ""
                          ),
                        )}
                  </div>
                </div>{" "}
                <div
                  class={`tab-pane fade ${this.state.tab === 8 && "show active"}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    {aviationModel &&
                      aviationModel.length > 0 &&
                      aviationModel
                        .sort((a, b) => facets["aviation_model_name"][b] - facets["aviation_model_name"][a])
                        .map((v) =>
                          v?.includes("_") ? (
                            <div class="form-check d-flex align-items-center">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id={v}
                                checked={aviationModelData.find((ev) => ev === v) ? true : false}
                              />
                              <label
                                class="form-check-label"
                                for={v}
                                onClick={() => this.props.setData("aviationModel", v)}
                              >
                                {`${v.split("_")[0]} (${
                                  facets["aviation_model_name"][v] ? facets["aviation_model_name"][v] : "0"
                                })`}
                              </label>
                            </div>
                          ) : (
                            ""
                          ),
                        )}
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${this.state.tab === 9 && "show active"}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    {condition && condition.length > 0
                      ? condition
                          ?.sort((a, b) => b[1] - a[1])
                          ?.map((v) => (
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={v[0]}
                                checked={conditionType.find((ev) => ev === v[0]) ? true : false}
                              />
                              <label
                                className="form-check-label"
                                for={v[0]}
                                onClick={() => this.props.setData("conditionType", v[0])}
                              >
                                {`${v[0]} (${v[1]})`}
                              </label>
                            </div>
                          ))
                      : ""}
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${this.state.tab === 3 && "show active"}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    {makefilter &&
                      makefilter.length > 0 &&
                      makefilter
                        .sort((a, b) => facets["make"][b] - facets["make"][a])
                        .map((v) => (
                          <div class="form-check d-flex align-items-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              id={v}
                              checked={make.find((ev) => ev === v) ? true : false}
                            />
                            <label class="form-check-label" for={v} onClick={() => this.props.setData("make", v)}>
                              {`${v} (${facets["make"][v]})`}
                            </label>
                          </div>
                        ))}
                  </div>
                </div>{" "}
                <div
                  class={`tab-pane fade ${this.state.tab === 4 && "show active"}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    {modelfilter &&
                      modelfilter.length > 0 &&
                      modelfilter
                        .sort((a, b) => facets["model"][b] - facets["model"][a])
                        .map((v) => (
                          <div class="form-check d-flex align-items-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              id={v}
                              checked={model.find((ev) => ev === v) ? true : false}
                            />
                            <label class="form-check-label" for={v} onClick={() => this.props.setData("model", v)}>
                              {`${v} (${facets["model"][v]})`}
                            </label>
                          </div>
                        ))}
                  </div>
                </div>{" "}
                <div
                  class={`tab-pane fade ${this.state.tab === 5 && "show active"}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    {regionfilter &&
                      regionfilter.length > 0 &&
                      regionfilter
                        .sort((a, b) => facets["region"][b] - facets["region"][a])
                        .map((v) => (
                          <div class="form-check d-flex align-items-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              id={v}
                              checked={region.find((ev) => ev === v) ? true : false}
                            />
                            <label class="form-check-label" for={v} onClick={() => this.props.setData("region", v)}>
                              {`${v} (${facets["region"][v]})`}
                            </label>
                          </div>
                        ))}
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${this.state.tab === 6 && "show active"}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box" style={{ padding: "0 15px" }}>
                    {subRegionfilter &&
                      subRegionfilter.length > 0 &&
                      subRegionfilter
                        .sort((a, b) => facets["regions.lvl1"][b] - facets["regions.lvl1"][a])
                        .map((v) => (
                          <div class="form-check d-flex align-items-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              id={v}
                              checked={region1.find((ev) => ev === v) ? true : false}
                            />
                            <label class="form-check-label" for={v} onClick={() => this.props.setData("region1", v)}>
                              {`${v} (${facets["regions.lvl1"][v]})`}
                            </label>
                          </div>
                        ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default MobileDropdown;
